import { isMobile } from 'is-mobile';
import { getActiveAccount } from '@near-wallet-selector/core';
import { signTransactions } from '@near-wallet-selector/wallet-utils';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var fails$7 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$6 = fails$7;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$6(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$5 = fails$7;

var functionBindNative = !fails$5(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var bind = FunctionPrototype$1.bind;
var call$4 = FunctionPrototype$1.call;
var uncurryThis$6 = NATIVE_BIND$1 && bind.bind(call$4, call$4);

var functionUncurryThis = NATIVE_BIND$1 ? function (fn) {
  return fn && uncurryThis$6(fn);
} : function (fn) {
  return fn && function () {
    return call$4.apply(fn, arguments);
  };
};

var $TypeError$5 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$1 = function (it) {
  if (it == undefined) throw $TypeError$5("Can't call method on " + it);
  return it;
};

var requireObjectCoercible = requireObjectCoercible$1;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$1 = function (argument) {
  return $Object$2(requireObjectCoercible(argument));
};

var uncurryThis$5 = functionUncurryThis;
var toObject = toObject$1;

var hasOwnProperty = uncurryThis$5({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var DESCRIPTORS$5 = descriptors;
var hasOwn$4 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;

var EXISTS$1 = hasOwn$4(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS$1 && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE$1 = EXISTS$1 && (!DESCRIPTORS$5 || (DESCRIPTORS$5 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS$1,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE$1
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$a = function (argument) {
  return typeof argument == 'function';
};

var objectDefineProperty = {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$9 =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var isCallable$9 = isCallable$a;

var isObject$5 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$9(it);
};

var global$8 = global$9;
var isObject$4 = isObject$5;

var document = global$8.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$4(document) && isObject$4(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

var DESCRIPTORS$4 = descriptors;
var fails$4 = fails$7;
var createElement = documentCreateElement;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$4 && !fails$4(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$3 = descriptors;
var fails$3 = fails$7;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$3 && fails$3(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$3 = isObject$5;

var $String$2 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$3 = function (argument) {
  if (isObject$3(argument)) return argument;
  throw $TypeError$4($String$2(argument) + ' is not an object');
};

var NATIVE_BIND = functionBindNative;

var call$3 = Function.prototype.call;

var functionCall = NATIVE_BIND ? call$3.bind(call$3) : function () {
  return call$3.apply(call$3, arguments);
};

var global$7 = global$9;
var isCallable$8 = isCallable$a;

var aFunction = function (argument) {
  return isCallable$8(argument) ? argument : undefined;
};

var getBuiltIn$2 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$7[namespace]) : global$7[namespace] && global$7[namespace][method];
};

var uncurryThis$4 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$4({}.isPrototypeOf);

var getBuiltIn$1 = getBuiltIn$2;

var engineUserAgent = getBuiltIn$1('navigator', 'userAgent') || '';

var global$6 = global$9;
var userAgent = engineUserAgent;

var process = global$6.process;
var Deno = global$6.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$2 = fails$7;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$2(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn = getBuiltIn$2;
var isCallable$7 = isCallable$a;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$1 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable$7($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$1(it));
};

var $String$1 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$1(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$6 = isCallable$a;
var tryToString = tryToString$1;

var $TypeError$3 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$6(argument)) return argument;
  throw $TypeError$3(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

var call$2 = functionCall;
var isCallable$5 = isCallable$a;
var isObject$2 = isObject$5;

var $TypeError$2 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$5(fn = input.toString) && !isObject$2(val = call$2(fn, input))) return val;
  if (isCallable$5(fn = input.valueOf) && !isObject$2(val = call$2(fn, input))) return val;
  if (pref !== 'string' && isCallable$5(fn = input.toString) && !isObject$2(val = call$2(fn, input))) return val;
  throw $TypeError$2("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$5 = global$9;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;

var defineGlobalProperty$2 = function (key, value) {
  try {
    defineProperty$1(global$5, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$5[key] = value;
  } return value;
};

var global$4 = global$9;
var defineGlobalProperty$1 = defineGlobalProperty$2;

var SHARED = '__core-js_shared__';
var store$3 = global$4[SHARED] || defineGlobalProperty$1(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.23.3',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var uncurryThis$3 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$2 = uncurryThis$3(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$2(++id + postfix, 36);
};

var global$3 = global$9;
var shared$2 = shared$3.exports;
var hasOwn$3 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$3.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$3 = function (name) {
  if (!hasOwn$3(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$3(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$1 = functionCall;
var isObject$1 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$2 = wellKnownSymbol$3;

var $TypeError$1 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$2('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$1(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$1(exoticToPrim, input, pref);
    if (!isObject$1(result) || isSymbol$1(result)) return result;
    throw $TypeError$1("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$1 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var DESCRIPTORS$2 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var anObject$2 = anObject$3;
var toPropertyKey = toPropertyKey$1;

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$2 ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject$2(O);
  P = toPropertyKey(P);
  anObject$2(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$2(O);
  P = toPropertyKey(P);
  anObject$2(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var makeBuiltIn$2 = {exports: {}};

var uncurryThis$2 = functionUncurryThis;
var isCallable$4 = isCallable$a;
var store$1 = sharedStore;

var functionToString = uncurryThis$2(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$4(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$2 = global$9;
var isCallable$3 = isCallable$a;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$2.WeakMap;

var nativeWeakMap = isCallable$3(WeakMap$1) && /native code/.test(inspectSource$1(WeakMap$1));

var createPropertyDescriptor$1 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$1 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$1;

var createNonEnumerableProperty$1 = DESCRIPTORS$1 ? function (object, key, value) {
  return definePropertyModule$1.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$1 = global$9;
var uncurryThis$1 = functionUncurryThis;
var isObject = isObject$5;
var createNonEnumerableProperty = createNonEnumerableProperty$1;
var hasOwn$2 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey = sharedKey$1;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$1.TypeError;
var WeakMap = global$1.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis$1(store.get);
  var wmhas = uncurryThis$1(store.has);
  var wmset = uncurryThis$1(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  set = function (it, metadata) {
    if (hasOwn$2(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$2(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$2(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$1 = fails$7;
var isCallable$2 = isCallable$a;
var hasOwn$1 = hasOwnProperty_1;
var DESCRIPTORS = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails$1(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$1(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$1(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$1(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$1(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$2(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

var isCallable$1 = isCallable$a;
var definePropertyModule = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty = defineGlobalProperty$2;

var defineBuiltIn$1 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$1(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var wellKnownSymbol$1 = wellKnownSymbol$3;

var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var uncurryThis = functionUncurryThis;

var toString$1 = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice(toString$1(it), 8, -1);
};

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable = isCallable$a;
var classofRaw = classofRaw$1;
var wellKnownSymbol = wellKnownSymbol$3;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var classof = classof$1;

var $String = String;

var toString = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var anObject$1 = anObject$3;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call = functionCall;
var hasOwn = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R)
    ? call(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$1;
var anObject = anObject$3;
var $toString = toString;
var fails = fails$7;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var icon = `data:image/png;base64,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`;

const isInstalled = () => {
  return !!window.coin98;
};

const setupCoin98WalletState = () => {
  const wallet = window.coin98;
  return {
    wallet
  };
};

const Coin98Wallet = ({
  metadata,
  options,
  store,
  provider,
  logger
}) => __awaiter(void 0, void 0, void 0, function* () {
  const _state = setupCoin98WalletState();

  const getAccounts = () => __awaiter(void 0, void 0, void 0, function* () {
    const accountId = _state.wallet.near.account;

    if (!accountId) {
      return [];
    }

    const publicKey = yield _state.wallet.near.signer.getPublicKey(accountId, options.network.networkId);
    return [{
      accountId,
      publicKey: publicKey ? publicKey.toString() : undefined
    }];
  });

  const transformTransactions = transactions => {
    const {
      contract
    } = store.getState();

    if (!contract) {
      throw new Error("Wallet not signed in");
    }

    const account = getActiveAccount(store.getState());

    if (!account) {
      throw new Error("No active account");
    }

    return transactions.map(transaction => {
      return {
        signerId: transaction.signerId || account.accountId,
        receiverId: transaction.receiverId || contract.contractId,
        actions: transaction.actions
      };
    });
  };

  return {
    signIn({
      contractId
    }) {
      return __awaiter(this, void 0, void 0, function* () {
        const existingAccounts = yield getAccounts();

        if (existingAccounts.length) {
          return existingAccounts;
        }

        yield _state.wallet.near.connect({
          prefix: "near_selector",
          contractId
        });
        return getAccounts();
      });
    },

    signOut() {
      return __awaiter(this, void 0, void 0, function* () {
        // Ignore if unsuccessful (returns false).
        yield _state.wallet.near.disconnect();
      });
    },

    getAccounts() {
      return __awaiter(this, void 0, void 0, function* () {
        return getAccounts();
      });
    },

    verifyOwner() {
      return __awaiter(this, void 0, void 0, function* () {
        throw new Error(`Method not supported by ${metadata.name}`);
      });
    },

    signAndSendTransaction({
      signerId,
      receiverId,
      actions
    }) {
      return __awaiter(this, void 0, void 0, function* () {
        logger.log("signAndSendTransaction", {
          signerId,
          receiverId,
          actions
        });
        const signedTransactions = yield signTransactions(transformTransactions([{
          signerId,
          receiverId,
          actions
        }]), _state.wallet.near.signer, options.network);
        return provider.sendTransaction(signedTransactions[0]);
      });
    },

    signAndSendTransactions({
      transactions
    }) {
      return __awaiter(this, void 0, void 0, function* () {
        logger.log("signAndSendTransactions", {
          transactions
        });
        const signedTransactions = yield signTransactions(transformTransactions(transactions), _state.wallet.near.signer, options.network);
        logger.log("signAndSendTransactions:signedTransactions", signedTransactions);
        const results = [];

        for (let i = 0; i < signedTransactions.length; i++) {
          results.push(yield provider.sendTransaction(signedTransactions[i]));
        }

        return results;
      });
    }

  };
});

const setupCoin98Wallet = ({
  iconUrl: _iconUrl = icon,
  deprecated: _deprecated = false
} = {}) => {
  return () => __awaiter(void 0, void 0, void 0, function* () {
    const mobile = isMobile();

    if (mobile) {
      return null;
    }

    const installed = isInstalled();
    return {
      id: "coin98-wallet",
      type: "injected",
      metadata: {
        name: "Coin98 Wallet",
        description: "Using a Decentralized Wallet With Experiences of a Centralized One",
        iconUrl: _iconUrl,
        downloadUrl: "https://chrome.google.com/webstore/detail/coin98-wallet/aeachknmefphepccionboohckonoeemg",
        deprecated: _deprecated,
        available: installed
      },
      init: Coin98Wallet
    };
  });
};

export { setupCoin98Wallet };
